<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <edit-betgame-form>

      </edit-betgame-form>
    </div>
  </div>
</template>
<script>
  import EditBetgameForm from './BGEditPrivacyForm.vue'

  export default {
    components: {
      EditBetgameForm
    },
    created () {
      this.$log.debug('BGEditPrivacy.created ' + this.$route.params.id)
    },
    beforeCreate () {
      this.$log.debug('BGEditPrivacy.beforeCreate ' + this.$route.params.id)
    },
    mounted () {
      this.$log.debug('BGEditPrivacy.mounted ' + this.$route.params.id)
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/BGBetgamePrivacy.vue